import PropTypes from 'prop-types';
import { Card, Accordion, Col } from 'react-bootstrap';
import { formatMoney } from '../services/helpers';
import useI18n from "../hooks/useI18n";
import { messages as jobmessages } from '../views/Job/Job.messages';

const PaymentDetails = (props) => {
    const lng = props.intl.formatMessage;
    const { getLocale } = useI18n();
    const userLocale = getLocale();

    // helper for getting values from job or subjob
    const getValue = (field) =>
        props.subjob === undefined
            ? formatMoney(props.job[field], userLocale, props.job.currency)
            : formatMoney(props.subjob[field], userLocale, props.subjob.currency);

    // payment details, ie. all fees related to the invoice / subjob
    return (
        <Accordion flush>
            <Accordion.Item eventKey='paymentdetails'>
                <Accordion.Header as="text" aria-label={lng(jobmessages.showDetails)}
                    id="paymentdetails-header"
                    title={lng(jobmessages.showDetails)}
                >
                    <Col as="span">
                        <span className='label'>
                            {lng(jobmessages.openTotal)}
                        </span>
                    </Col>
                    <Col as="span" className='float-end text-end pe-2 pe-lg-3'>
                        {formatMoney(props.openamount, userLocale, props.job.currency)}
                    </Col>
                </Accordion.Header>
                <Accordion.Body className='pe-0 pb-0'>
                    <Card className={'fullwidth-mobile no-box-shadow p-0 mb-0'}>
                        <Card.Body className='p-0'>
                            <ul className='list-unstyled' aria-labelledby="paymentdetails-header">
                                <li id='paymentdetails-openamount'>
                                    <span className='text-muted'>{lng(jobmessages.openTotal)} </span>
                                    <span
                                        className='float-end text-end text-muted'
                                        aria-live='polite'
                                    >
                                        {getValue('openamount')}
                                    </span>
                                </li>
                                <li id='paymentdetails-opencapital'>
                                    {lng(jobmessages.openCapital)}
                                    <span
                                        className='float-end text-end'
                                        aria-live='polite'
                                    >
                                        {getValue('opencapital')}
                                    </span>
                                </li>
                                <li id='paymentdetails-openexpenses'>
                                    {lng(jobmessages.openExpenses)}
                                    <span
                                        className='float-end text-end'
                                        aria-live='polite'
                                    >
                                        {getValue('openexpenses')}
                                    </span>
                                </li>
                                <li id='paymentdetails-openinterest'>
                                    {lng(jobmessages.lateInterest)}
                                    <span
                                        className='float-end text-end'
                                        aria-live='polite'
                                    >
                                        {getValue('openinterest')}
                                    </span>
                                </li>
                                {props.subjob === undefined && props.job.paidamount !== undefined ? (
                                    <li id='paymentdetails-paidamount'>
                                        {lng(jobmessages.paid)}
                                        <span
                                            className='float-end text-end'
                                            aria-live='polite'
                                        >
                                            {getValue('paidamount')}
                                        </span>
                                    </li>
                                ) : ('')}
                            </ul>
                        </Card.Body>
                    </Card>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

PaymentDetails.propTypes = {
    'intl': PropTypes.object.isRequired,
    'job': PropTypes.object,
    'subjob': PropTypes.object,
    'openamount': PropTypes.number
};

export default PaymentDetails;